import {
  UPLOAD_NOC,
  UPLOAD_NOC_SUCCESS,
  UPLOAD_NOC_ERROR,
  DOWNLOAD_NOC_DOCUMENT,
  DOWNLOAD_NOC_DOCUMENT_SUCCESS,
  DOWNLOAD_NOC_DOCUMENT_ERROR,
  FILTER_NOC_DOCUMENT,
  FILTER_NOC_DOCUMENT_SUCCESS,
  FILTER_NOC_DOCUMENT_ERROR,
  GET_NOC_LIST,
  GET_NOC_LIST_SUCCESS,
  DELETE_NOC_LIST,
  DELETE_NOC_LIST_SUCCESS,
  NOC_API_ERROR_ACTION,
} from "./actionType";

// ===== Upload NOC Document =====
export const uploadNocDocument = (config = {}) => ({
  type: UPLOAD_NOC,
  config,
});

export const uploadNocDocumentSuccess = (response) => ({
  type: UPLOAD_NOC_SUCCESS,
  payload: response,
});

export const uploadNocDocumentError = (error) => ({
  type: UPLOAD_NOC_ERROR,
  error,
});

// ===== Download NOC Document =====
export const downloadNocDocument = (payload) => ({
  type: DOWNLOAD_NOC_DOCUMENT,
  payload,
});

export const downloadNocDocumentSuccess = (response) => ({
  type: DOWNLOAD_NOC_DOCUMENT_SUCCESS,
  payload: response,
});

export const downloadNocDocumentError = (error) => ({
  type: DOWNLOAD_NOC_DOCUMENT_ERROR,
  error,
});

export const filterNocDocument = (payload) => ({
  type: FILTER_NOC_DOCUMENT,
  payload,
});

export const filterNocDocumentSuccess = (response) => ({
  type: FILTER_NOC_DOCUMENT_SUCCESS,
  payload: response,
  
});

export const filterNocDocumentError = (error) => ({
  type: FILTER_NOC_DOCUMENT_ERROR,
  error,
});
// Get NOC List
export const getNocList = (config = {}) => ({
  type: GET_NOC_LIST,
  config,
});

export const getNocListSuccess = (resp) => ({
  type: GET_NOC_LIST_SUCCESS,
  payload: resp,
});

// Delete NOC document
export const deleteNocList_Id = (payload) => ({
  type: DELETE_NOC_LIST,
  payload,
});

export const deleteNocList_Id_Success = (resp) => ({
  type: DELETE_NOC_LIST_SUCCESS,
  payload: resp,
});

export const nocApiErrorAction = (error) => ({
  type: NOC_API_ERROR_ACTION,
  payload: error,
});

